import React from "react";
import { Typography } from "@mui/material";
import ImportarPlanilhaDialog from "../../components/ImportarPlanilhaDialog";
import { COLUNAS_PREVIA_CADASTRO } from "../Fornecedores/ImportarFornecedoresDialog";
import { ClienteService } from "../../service/cliente_service";
import { baixarModeloImportacaoClientes, lerPlanilhaClientes } from "../../utils/importacaoClientes";

/** Importação de clientes por planilha: mesmas regras da de fornecedores. */
function ImportarClientesDialog({ open, onClose, onImportado, unidadeDistribuidoraId }) {
	const service = new ClienteService();
	return (
		<ImportarPlanilhaDialog
			open={open}
			onClose={onClose}
			onImportado={onImportado}
			titulo="Importar clientes de planilha"
			entidade={{ singular: "cliente", plural: "clientes", contagem: "cliente(s)" }}
			instrucoes={
				<>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Colunas obrigatórias: <strong>Nome</strong> e <strong>CPF/CNPJ</strong>. Opcionais: Nome Fantasia,
						IE/RG, E-mail, Telefone, CEP, UF, Cidade, Bairro, Logradouro, Latitude, Longitude, Data de entrada
						na base e Produtos.
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Em <strong>Produtos</strong>, separe por ponto e vírgula e use o nome do cultivo como está no sistema,
						com a unidade entre parênteses se quiser: <em>Alface - Crespa (kg); Tomate - Cereja (un)</em>. Produto
						sem correspondência no cadastro de cultivos não é vinculado e aparece como aviso na prévia.
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Clientes com CPF/CNPJ já cadastrado nesta unidade não são duplicados: o cadastro atual é mantido
						como está. Antes de gravar, você confere linha a linha o que vai entrar.
					</Typography>
				</>
			}
			ler={lerPlanilhaClientes}
			baixarModelo={baixarModeloImportacaoClientes}
			previa={(linhas) => service.previaImportacao(unidadeDistribuidoraId, linhas)}
			importar={(linhas) => service.importar(unidadeDistribuidoraId, linhas)}
			colunas={COLUNAS_PREVIA_CADASTRO}
			textoAvisos="Algumas linhas têm avisos (em laranja): o cliente entra, mas o item citado fica de fora. Você pode corrigir a planilha e enviar de novo, ou completar depois no cadastro do cliente."
		/>
	);
}

export default ImportarClientesDialog;
